import { EventoTimeline } from '@/api.types';

interface CalendarioAnualProps {
  ano: number;
  eventosTimeline: EventoTimeline[];
  onDiaClick: (data: Date, eventos: EventoTimeline[]) => void;
}

export default function CalendarioAnual({ ano, eventosTimeline, onDiaClick }: CalendarioAnualProps) {
  const meses = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
  ];

  const diasSemana = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

  const getDiasNoMes = (mes: number, ano: number) => {
    return new Date(ano, mes + 1, 0).getDate();
  };

  const getPrimeiroDiaSemana = (mes: number, ano: number) => {
    return new Date(ano, mes, 1).getDay();
  };

  const getEventosNaData = (data: Date): EventoTimeline[] => {
    return eventosTimeline.filter((evento) => {
      const dataEvento = new Date(evento.inicio);
      const dataFim = evento.termino ? new Date(evento.termino) : null;

      if (
        dataEvento.getFullYear() === data.getFullYear() &&
        dataEvento.getMonth() === data.getMonth() &&
        dataEvento.getDate() === data.getDate()
      ) {
        return true;
      }

      if (dataFim) {
        const dataSelecionadaTime = new Date(
          data.getFullYear(),
          data.getMonth(),
          data.getDate()
        ).getTime();
        const inicioTime = new Date(
          dataEvento.getFullYear(),
          dataEvento.getMonth(),
          dataEvento.getDate()
        ).getTime();
        const fimTime = new Date(
          dataFim.getFullYear(),
          dataFim.getMonth(),
          dataFim.getDate()
        ).getTime();

        return dataSelecionadaTime >= inicioTime && dataSelecionadaTime <= fimTime;
      }

      return false;
    });
  };

  const hoje = new Date();
  const hojeTime = new Date(
    hoje.getFullYear(),
    hoje.getMonth(),
    hoje.getDate()
  ).getTime();

  const renderMes = (mes: number) => {
    const diasNoMes = getDiasNoMes(mes, ano);
    const primeiroDiaSemana = getPrimeiroDiaSemana(mes, ano);
    const dias: (number | null)[] = [];

    // Adiciona células vazias antes do primeiro dia do mês
    for (let i = 0; i < primeiroDiaSemana; i++) {
      dias.push(null);
    }

    // Adiciona os dias do mês
    for (let dia = 1; dia <= diasNoMes; dia++) {
      dias.push(dia);
    }

    return (
      <div key={mes} className="col-md-3 mb-4">
        <div className="card h-100">
          <div className="card-header text-center bg-light">
            <strong>{meses[mes]} {ano}</strong>
          </div>
          <div className="card-body p-2">
            <div className="calendario-mes">
              <div className="calendario-dias-semana">
                {diasSemana.map((dia, index) => (
                  <div key={index} className="calendario-dia-semana">
                    {dia}
                  </div>
                ))}
              </div>
              <div className="calendario-dias">
                {dias.map((dia, index) => {
                  if (dia === null) {
                    return <div key={index} className="calendario-dia vazio"></div>;
                  }

                  const data = new Date(ano, mes, dia);
                  const dataTime = new Date(
                    data.getFullYear(),
                    data.getMonth(),
                    data.getDate()
                  ).getTime();
                  const isHoje = dataTime === hojeTime;
                  const eventos = getEventosNaData(data);
                  const temEvento = eventos.length > 0;

                  return (
                    <div
                      key={index}
                      className={`calendario-dia ${isHoje ? 'hoje' : ''} ${temEvento ? 'com-evento' : ''}`}
                      onClick={() => {
                        if (temEvento) {
                          onDiaClick(data, eventos);
                        }
                      }}
                      style={{
                        cursor: temEvento ? 'pointer' : 'default'
                      }}
                    >
                      {dia}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="row">
        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(renderMes)}
      </div>
      <style>{`
        .calendario-mes {
          display: flex;
          flex-direction: column;
        }
        
        .calendario-dias-semana {
          display: grid;
          grid-template-columns: repeat(7, 1fr);
          gap: 2px;
          margin-bottom: 4px;
        }
        
        .calendario-dia-semana {
          text-align: center;
          font-weight: bold;
          font-size: 0.75rem;
          padding: 4px 2px;
          color: #666;
        }
        
        .calendario-dias {
          display: grid;
          grid-template-columns: repeat(7, 1fr);
          gap: 2px;
        }
        
        .calendario-dia {
          aspect-ratio: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.85rem;
          border: 1px solid #e0e0e0;
          border-radius: 3px;
          transition: all 0.2s;
          min-height: 30px;
        }
        
        .calendario-dia.vazio {
          border: none;
          background: transparent;
        }
        
        .calendario-dia:hover:not(.vazio) {
          background-color: #f0f0f0;
        }
        
        .calendario-dia.hoje {
          background-color: #ffff76;
          font-weight: bold;
        }
        
        .calendario-dia.com-evento {
          background-color: #28a745 !important;
          color: white !important;
          font-weight: bold;
        }
        
        .calendario-dia.com-evento:hover {
          background-color: #218838 !important;
        }
      `}</style>
    </>
  );
}
